"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeatureEnum = void 0;
/** Фичи */
var FeatureEnum;
(function (FeatureEnum) {
  /** Показывать уведомление об HTTP ошибках */
  FeatureEnum[FeatureEnum["httpErrors"] = 2] = "httpErrors";
  // ----------------------------------------------
  /** Первая версия билинга */
  FeatureEnum[FeatureEnum["billing_v1"] = 10] = "billing_v1";
  /**
   * Вторая версия билинга
   *
   * @see git.onclass.tech/onclass/lingo2-billing
   */
  FeatureEnum[FeatureEnum["billing_v2"] = 11] = "billing_v2";
  // ----------------------------------------------
  /** Услуги преподавателя */
  FeatureEnum[FeatureEnum["user_services"] = 50] = "user_services";
  /** Услуги преподавателя - конструктор для групповых регулярных */
  FeatureEnum[FeatureEnum["services_constructor_group_regular"] = 51] = "services_constructor_group_regular";
  /** Услуги преподавателя - запись на серийные занятия */
  FeatureEnum[FeatureEnum["services_signup_series"] = 52] = "services_signup_series";
  /** Услуги преподавателя - запись на регулярные */
  FeatureEnum[FeatureEnum["services_signup_ongoing"] = 53] = "services_signup_ongoing";
  // ----------------------------------------------
  /** Режим отпуска */
  FeatureEnum[FeatureEnum["schedule_vacation"] = 100] = "schedule_vacation";
  /** Рабочее расписание */
  FeatureEnum[FeatureEnum["schedule_working_schedule"] = 101] = "schedule_working_schedule";
  // ----------------------------------------------
  /** совершенно бесплатные митинги */
  FeatureEnum[FeatureEnum["free_meetings"] = 150] = "free_meetings";
  /** Митинги с кредитной формой расчёты */
  FeatureEnum[FeatureEnum["credits_meetings"] = 151] = "credits_meetings";
  /** Митинги с формой расчёта "безопасная сделка" */
  FeatureEnum[FeatureEnum["safe_deal_meetings"] = 152] = "safe_deal_meetings";
  /** "Быстрые" митинги (черновики) */
  FeatureEnum[FeatureEnum["draft_meetings"] = 153] = "draft_meetings";
  // ----------------------------------------------
  /** Классные комнаты */
  FeatureEnum[FeatureEnum["classrooms"] = 200] = "classrooms";
  /** Раздел "Избранное" */
  FeatureEnum[FeatureEnum["favorites_page"] = 201] = "favorites_page";
  /** Уведомления "Колокольчики" */
  FeatureEnum[FeatureEnum["notifications"] = 202] = "notifications";
  /** Мобильные приложения "Onclass.Messenger" */
  FeatureEnum[FeatureEnum["mobile_apps"] = 203] = "mobile_apps";
  /** Чат */
  FeatureEnum[FeatureEnum["chat"] = 204] = "chat";
  /** Коллекции */
  FeatureEnum[FeatureEnum["collections"] = 205] = "collections";
  /** Курсы ? */
  FeatureEnum[FeatureEnum["courses"] = 206] = "courses";
  // ----------------------------------------------
  /** настройки пользователя [/me/settings] */
  FeatureEnum[FeatureEnum["profile_settings"] = 250] = "profile_settings";
  /** баланс пользователя [/me/finance] */
  FeatureEnum[FeatureEnum["profile_finance"] = 251] = "profile_finance";
  /** реферальная система */
  FeatureEnum[FeatureEnum["finance_referrals"] = 252] = "finance_referrals";
  /** выплата [/me/finance/payouts] */
  FeatureEnum[FeatureEnum["finance_payouts"] = 253] = "finance_payouts";
  /** подписки */
  FeatureEnum[FeatureEnum["finance_plans"] = 254] = "finance_plans";
  /** купоны */
  FeatureEnum[FeatureEnum["finance_coupons"] = 255] = "finance_coupons";
  /** Трекеры активности преподавателя */
  FeatureEnum[FeatureEnum["onboarding_trackers"] = 256] = "onboarding_trackers";
  /** запись видео с веб-камеры в профиле */
  FeatureEnum[FeatureEnum["teaching_video_webcam"] = 257] = "teaching_video_webcam";
  // ----------------------------------------------
  /** Словарный запас */
  FeatureEnum[FeatureEnum["vocabulary"] = 300] = "vocabulary";
  /** создать урок из слов */
  FeatureEnum[FeatureEnum["vocabulary_lesson"] = 301] = "vocabulary_lesson";
  // ----------------------------------------------
  /** Показать главную страницу */
  FeatureEnum[FeatureEnum["main"] = 302] = "main";
  /** Страница подписок */
  FeatureEnum[FeatureEnum["following"] = 303] = "following";
  /** Закрепить классрум */
  FeatureEnum[FeatureEnum["pins"] = 304] = "pins";
  /** Таб услуг в редактировании профиля */
  FeatureEnum[FeatureEnum["profile_step_services"] = 305] = "profile_step_services";
  /** Таб календаря в редактировании профиля */
  FeatureEnum[FeatureEnum["profile_step_calendar"] = 306] = "profile_step_calendar";
  /** Таб скачать приложение в редактировании профиля */
  FeatureEnum[FeatureEnum["profile_step_app"] = 308] = "profile_step_app";
  /** Таб домашних работ */
  FeatureEnum[FeatureEnum["my_classes_homework"] = 309] = "my_classes_homework";
  /** Таб школ */
  FeatureEnum[FeatureEnum["my_classes_schools"] = 310] = "my_classes_schools";
  /** Таб преподавателей */
  FeatureEnum[FeatureEnum["my_classes_tutors"] = 311] = "my_classes_tutors";
  /** Таб учеников */
  FeatureEnum[FeatureEnum["my_classes_students"] = 312] = "my_classes_students";
  /** Таб моих услуг */
  FeatureEnum[FeatureEnum["my_library_services"] = 313] = "my_library_services";
  /** Таб моих коллекций */
  FeatureEnum[FeatureEnum["my_library_collections"] = 314] = "my_library_collections";
  /** Виджет ближайшего занятия */
  FeatureEnum[FeatureEnum["nearest_meet_widget"] = 315] = "nearest_meet_widget";
  /** Статистика учителя */
  FeatureEnum[FeatureEnum["statistics"] = 316] = "statistics";
  /** Безопасная сделка */
  FeatureEnum[FeatureEnum["safe_transaction"] = 317] = "safe_transaction";
  /** Таб услуг в профиле */
  FeatureEnum[FeatureEnum["profile_services"] = 318] = "profile_services";
  /** Таб коллекций в профиле */
  FeatureEnum[FeatureEnum["profile_collections"] = 319] = "profile_collections";
  /** Таб школ в профиле */
  FeatureEnum[FeatureEnum["profile_schools"] = 320] = "profile_schools";
  /** Таб публикаций в профиле */
  FeatureEnum[FeatureEnum["profile_publications"] = 321] = "profile_publications";
  /** Таб отзывов в профиле */
  FeatureEnum[FeatureEnum["profile_reviews"] = 322] = "profile_reviews";
  /** Таб уроков в профиле */
  FeatureEnum[FeatureEnum["profile_lessons"] = 323] = "profile_lessons";
})(FeatureEnum = exports.FeatureEnum || (exports.FeatureEnum = {}));
